'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _config = require('../../theme/config');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _dofDiamondTab = require('../dof-diamond-tab');

var _dofDiamondTab2 = _interopRequireDefault(_dofDiamondTab);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofDiamondTab: _dofDiamondTab2.default },
  props: {
    type: {
      type: String,
      default: 'secondary'
    },
    theme: {
      type: String,
      default: 'default'
    },
    isSlot: {
      type: Boolean,
      default: false
    },
    tabTitles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabCheckedIndex: {
      type: [Number, String],
      default: 0
    },
    tabStyles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasMargin: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: ''
    },
    isFlexStart: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentPage: 0
    };
  },
  computed: {
    defaultStyleOption: function defaultStyleOption() {
      var base = {
        isActiveTitleBold: true,
        iconWidth: 70,
        iconHeight: 70,
        height: 88,
        fontSize: 24,
        hasActiveBottom: true,
        activeBottomColor: '#1E2E37',
        hasRightIcon: false
      };
      var defaultStyle = _extends({}, base, {
        bgColor: '#ffffff',
        titleColor: '#8E969B',
        activeTitleColor: '#1E2E37',
        boxBgColor: '#F6F7F9',
        activeBoxBgColor: '#232323'
      });
      var colmoStyle = _extends({}, base, {
        isActiveTitleBold: false,
        bgColor: '#151617',
        titleColor: 'rgba(255,255,255,0.4)',
        activeTitleColor: 'rgba(255,255,255,0.8)',
        boxBgColor: '#151617',
        activeBoxBgColor: '#151617',
        activeBottomColor: '#B35336',
        borderColor: 'rgba(51, 51, 51, 1)',
        activeBorderColor: '#B35336'
      });
      var diabloStyle = _extends({}, base, {
        bgColor: '#101315',
        titleColor: '#8E969B',
        activeTitleColor: '#cfcfd0',
        activeBottomColor: '#cfcfd0',
        boxBgColor: '#171c1f',
        activeBoxBgColor: '#cfcfd0'
      });
      return this._isColmo ? colmoStyle : this._isDiablo ? diabloStyle : defaultStyle;
    },
    mergeStyleOption: function mergeStyleOption() {
      var type = this.type,
          theme = this.theme,
          tabStyles = this.tabStyles,
          defaultStyleOption = this.defaultStyleOption;

      if (type === 'third') {
        if (this._isColmo) {
          var res = _extends({}, defaultStyleOption, tabStyles);
          if (this.bgColor) res.bgColor = this.bgColor;
          return res;
        }
        if (theme === 'default') {
          return _extends({}, defaultStyleOption, {
            activeTitleColor: this._isDiablo ? '#1e2e37' : '#fff',
            titleColor: this._isDiablo ? 'rgba(255,255,255,0.4)' : '#1e2e37'
          }, tabStyles);
        } else if (theme === 'primary') {
          return _extends({}, defaultStyleOption, tabStyles, {
            bgColor: _config.THEME_COLOR_SET[theme],
            // boxBgColor: '#5088ff',
            boxBgColor: THEME_BOX_BGCOLOR_SET[theme],
            activeBoxBgColor: '#ffffff',
            titleColor: '#ffffff',
            activeTitleColor: _config.THEME_COLOR_SET[theme]
          });
        } else {
          return _extends({}, defaultStyleOption, tabStyles, { boxBgColor: THEME_BOX_BGCOLOR_SET[theme] });
        }
      } else if (type === 'third-group') {
        if (this._isColmo) return { bgColor: '#151617' };
        return { bgColor: this._isDiablo ? '#101315' : _config.THEME_COLOR_SET[theme] };
      } else {
        if (theme === 'default') {
          var _res = this.bgColor ? { bgColor: this.bgColor } : {};
          return _extends({}, defaultStyleOption, tabStyles, _res);
        } else {
          return _extends({}, defaultStyleOption, tabStyles, {
            bgColor: _config.THEME_COLOR_SET[theme],
            titleColor: 'rgba(255,255,255, 0.6)',
            activeTitleColor: '#ffffff',
            activeBottomColor: '#ffffff'
          });
        }
      }
    },


    // 新增三类固定标签
    wrapStyle: function wrapStyle() {
      var theme = this.theme;

      if (theme == 'default') {
        return {
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: this._isDiablo ? '#1E2123' : '#f3f4f4'
        };
      } else {
        return {
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: 'rgba(255, 255, 255, 0.3)'
        };
      }
    },
    textStyle: function textStyle() {
      var theme = this.theme;

      if (theme == 'default') {
        return {
          color: this._isDiablo ? '#797c7e' : '#8E969B'
        };
      } else {
        return {
          color: '#ffffff'
        };
      }
    },
    verticalLineStyle: function verticalLineStyle() {
      var theme = this.theme;

      if (theme == 'default') {
        return {
          borderRightWidth: '2px',
          borderRightStyle: 'solid',
          borderRightColor: this._isDiablo ? '#1E2123' : '#f3f4f4'
        };
      } else {
        return {
          borderRightWidth: '2px',
          borderRightStyle: 'solid',
          borderRightColor: 'rgba(255, 255, 255, 0.3)'
        };
      }
    },
    hackMarginTop: function hackMarginTop() {
      // const platform = weex.config.env.platform
      // if (platform === 'iOS') return -1
      // if (platform === 'harmony') return 0
      // return 2
      return 0;
    },
    textBtnStyle: function textBtnStyle() {
      var theme = this.theme;

      var hackH = this.hackMarginTop;
      return function (i) {
        if (theme == 'default') {
          return {
            color: this._isDiablo ? '#cfcfd0' : '#1E2E37',
            backgroundColor: this._isDiablo ? '#1E2123' : '#f3f4f4',
            marginTop: hackH + 'px'
          };
        } else {
          return {
            color: _config.THEME_COLOR_SET[theme],
            backgroundColor: '#FFFFFF',
            marginTop: hackH + 'px'
          };
        }
      };
    }
  },
  methods: {
    onClicked: function onClicked(index, len) {
      this.currentPage = index;
      this.$emit('dofTabSelected', { index: index });
      len > 4 && this._scrollToCurrentTab(index);
    },
    tabActiveChange: function tabActiveChange(index) {
      this.onClicked(index);
    },
    _scrollToCurrentTab: function _scrollToCurrentTab(index) {
      var currentTabEl = this.$refs['dof-tab-title-' + index][0];
      var firstTabEl = this.$refs['dof-tab-title-0'][0];
      var SAFE_DISTANCE = 16.3;

      dom.getComponentRect(currentTabEl, function (res) {
        var _res$size = res.size,
            height = _res$size.height,
            _res$size$width = _res$size.width,
            width = _res$size$width === undefined ? 110 : _res$size$width,
            left = _res$size.left;

        var appearNum = Math.floor(750 / (width + SAFE_DISTANCE));
        var offset = -(750 - width) / 2 | 0;

        if (index + 1 < appearNum) {
          dom.scrollToElement(firstTabEl, {
            offset: -16.3
          });
        } else {
          dom.scrollToElement(currentTabEl, {
            offset: offset,
            animated: true
          });
        }
      });
    },

    // 三类固定
    onTextClicked: function onTextClicked(index) {
      // weex下不能完成事件委托
      this.tabCheckedIndex = index;
      this.$emit('dofTabSelected', { index: index });
    },
    dotNum: function dotNum(content, max) {
      var value = '';
      var curContent = Number(content);
      if (max && curContent >= max) {
        value = max + '+';
      } else {
        value = content;
      }
      return value;
    }
  },
  watch: {
    tabCheckedIndex: {
      handler: function handler(n, o) {
        var _this = this;

        var len = this.tabTitles.length - 1;
        len >= +n ? this.currentPage = +n : this.currentPage = len;
        if (len > 4) {
          this.$nextTick(function () {
            _this._scrollToCurrentTab(n);
          });
        }
      },

      immediate: true
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-tab-page/index.vue
// module id = 406
// module chunks = 0 1